var render, staticRenderFns
import script from "./summernote.vue?vue&type=script&lang=js&"
export * from "./summernote.vue?vue&type=script&lang=js&"
import style0 from "./summernote.vue?vue&type=style&index=0&id=010e5e9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e5e9c",
  null
  
)

export default component.exports